export function initImageZoom(): void {
    const items: NodeListOf<HTMLElement> = document.querySelectorAll('.js-trigger-gallery');
    const zoomBox: HTMLElement | null = document.querySelector('.js-zoom-result');

    if (!items.length || !zoomBox) return;

    const zoom = 2;
    const mq = window.matchMedia('(min-width: 1200px)');

    let isEnabled = false;

    const enable = (): void => {
        if (isEnabled) return;
        isEnabled = true;

        items.forEach((item: HTMLElement) => {
            const img = item.querySelector('img') as HTMLImageElement | null;
            if (!img) return;

            const mouseMoveHandler = (e: MouseEvent): void => {
                const rect: DOMRect = img.getBoundingClientRect();

                let x: number = e.clientX - rect.left;
                let y: number = e.clientY - rect.top;

                x = Math.max(0, Math.min(x, rect.width));
                y = Math.max(0, Math.min(y, rect.height));

                const bgWidth = rect.width * zoom;
                const bgHeight = rect.height * zoom;

                zoomBox.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;

                const posX = (x / rect.width) * (bgWidth - zoomBox.clientWidth);
                const posY = (y / rect.height) * (bgHeight - zoomBox.clientHeight);

                zoomBox.style.backgroundPosition = `-${posX}px -${posY}px`;
            };

            const enterHandler = (): void => {
                zoomBox.style.backgroundImage = `url(${img.src})`;
                zoomBox.style.backgroundRepeat = 'no-repeat';
                zoomBox.classList.add('active');

                item.addEventListener('mousemove', mouseMoveHandler);
            };

            const leaveHandler = (): void => {
                zoomBox.classList.remove('active');
                item.removeEventListener('mousemove', mouseMoveHandler);
            };

            item.addEventListener('mouseenter', enterHandler);
            item.addEventListener('mouseleave', leaveHandler);
        });
    };

    const disable = (): void => {
        if (!isEnabled) return;
        isEnabled = false;

        zoomBox.classList.remove('active');
    };

    const check = (): void => {
        if (mq.matches) {
            enable();
        } else {
            disable();
        }
    };

    // первичная проверка
    check();

    // отслеживание ресайза
    mq.addEventListener('change', check);
}